var api = require('../../../utils/api');

var constants = require('../constants');

var PracticeActions = (function () {
  var _setPracticeFromSubdomainSuccess = function (data) {
    return {
      type: constants.SET_PRACTICE_FROM_SUBDOMAIN_SUCCESS,
      practice: data.practice || {},
    }
  }

  var _setPracticeFromSubdomainRequest = function () {
    return {
      type: constants.SET_PRACTICE_FROM_SUBDOMAIN_REQUEST
    };
  }

  var _setPracticeFromSubdomainFailure = function (error) {
    return {
      type: constants.SET_PRACTICE_FROM_SUBDOMAIN_FAILURE,
      error: error
    };
  }

  var _setPracticeFromSubdomain = function (subdomain) {
    return function (dispatch) {
      dispatch(_setPracticeFromSubdomainRequest());

      return api.get('/proxy/v1/practices?subdomain=' + subdomain).then(function (data) {
        return dispatch(_setPracticeFromSubdomainSuccess(data));
      }).catch(function (error) {
        dispatch(_setPracticeFromSubdomainFailure(error));
      });
    };
  }

  return {
    setPracticeFromSubdomain: _setPracticeFromSubdomain,
  }
})();

module.exports = PracticeActions;



// WEBPACK FOOTER //
// ./src/common/modules/practice/actions/practice.js